import { ref } from 'vue';

// Modul-Level — wird einmal erstellt und von allen Komponenten geteilt
const toasts = ref([]);
let nextId = 0;

export function useToast() {
  function show(message, type = 'info', duration = 3500) {
    const id = ++nextId;
    toasts.value.push({ id, message, type });
    setTimeout(() => remove(id), duration);
  }

  function remove(id) {
    const i = toasts.value.findIndex(t => t.id === id);
    if (i > -1) toasts.value.splice(i, 1);
  }

  return {
    toasts,
    success: (msg) => show(msg, 'success'),
    error:   (msg) => show(msg, 'error', 5000),
    info:    (msg) => show(msg, 'info'),
    warning: (msg) => show(msg, 'warning'),
    remove,
  };
}